import { useState, useCallback } from 'react';

/**
 * useTextLink
 *
 * Owns the text-link / SMS state that was previously class state on FormViewer:
 *
 *   handleSendTextLinkMessage(name, number, carrier, message, carrierDomain)
 *     — sends text-link message via calc engine
 *
 * State returned for render:
 *   showTextLinkSendErrorDialog — boolean
 *   textlinkErrorMessage        — string
 *   isTextlinkPDFOpen           — boolean
 *   textlinkPDF                 — string (PDF identifier)
 *
 * Callers must supply:
 *   calcAPIRef              — ref to CalcAPI instance
 *   returnIDRef             — ref to current returnID
 *   onToggleTextLinkSendModal — Redux action
 */
const useTextLink = ({ calcAPIRef, returnIDRef, onToggleTextLinkSendModal }) => {
  const [showTextLinkSendErrorDialog, setShowTextLinkSendErrorDialog] = useState(false);
  const [textlinkErrorMessage, setTextlinkErrorMessage] = useState('');
  const [isTextlinkPDFOpen, setIsTextlinkPDFOpen] = useState(false);
  const [textlinkPDF, setTextlinkPDF] = useState('');

  const handleSendTextLinkMessage = useCallback(
    (name, number, carrier, message, carrierDomain) => {
      const msg = {
        name,
        number,
        carrier,
        message,
        carrierDomain,
        returnID: returnIDRef.current,
      };
      calcAPIRef.current?.SendTextLinkMessage(msg);
      onToggleTextLinkSendModal(false, '');
    },
    [calcAPIRef, returnIDRef, onToggleTextLinkSendModal],
  );

  return {
    showTextLinkSendErrorDialog,
    setShowTextLinkSendErrorDialog,
    textlinkErrorMessage,
    setTextlinkErrorMessage,
    isTextlinkPDFOpen,
    setIsTextlinkPDFOpen,
    textlinkPDF,
    setTextlinkPDF,
    handleSendTextLinkMessage,
  };
};

export default useTextLink;
